import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {
    CmsStructureModel,
    ConverterService,
    OccCmsPageAdapter,
    OccEndpointsService,
    PageContext
} from "@spartacus/core";


@Injectable({
    providedIn: 'root',
})
export class AimoOccCmsPageAdapter extends OccCmsPageAdapter {

    constructor(
        protected http: HttpClient,
        protected occEndpoints: OccEndpointsService,
        protected converter: ConverterService
    ) {
        super(http, occEndpoints, converter);
    }

    load(pageContext: PageContext): Observable<CmsStructureModel> {
        if (pageContext.id === '/undefined') {
            return super.load({...pageContext, id: '/'});
        }
        return super.load(pageContext);
    }
}
